export const SiteinformationListSelector = ({
  siteinformationstore: { SiteinformationList }
}) => SiteinformationList;
export default SiteinformationListSelector;

export const SiteinformationSelector = ({
  Siteinformationdata: { SiteinformationSuccess }
}) => SiteinformationSuccess;
